/*  topcg/scr/store.js
      Establece la inicialización con Firebase y el almacen con las variables globales.

      Muestra el menú de opciones    
======================================================================================================== */    

import Vue from 'vue';
import Vuex from 'vuex';

import {db, rutaCasos, rutaUsuarios, dbCasos, dbUsuarios} from './myFirebaseApp'

import {getters}    from './getters'
import {mutations}  from './mutations';

Vue.use(Vuex);

/* Exportamos a través de la constante STORE los valores de la base de datos (db) 
   la ruta, path o nodo a acceder */
export const store = new Vuex.Store({

    state: {
        auth: true, 
        /** Obtiene el path del nodo de los casos y usuarios, así como la referencia para su acceso (st_dbxyz) */
        st_db:              db, 
        st_rutaCasos:       rutaCasos,                 
        st_rutaUsuarios:    rutaUsuarios,

        st_dbCasos:         dbCasos,
        st_dbUsuarios:      dbUsuarios,

        /** Datos del usuario en sesión */
        st_logeado:     false,      // Está logeado
        st_usuario:     "",         // Almacena la UID del usuario
        st_clave:       "",         // Clave del usuario
        st_email:       "",         // Email
        st_nusuario:    "",         // Nombre del usuario
        st_usuarios:    [],         // Objeto con el nodo de los usuarios
        st_roles:       "",         // Roles del usuario en sesión
        st_activo:      "",         // Está activo el usuario ?
        st_admin:       false,      // Si es Administrador.
        st_empresa:     "",         // Nombre de la empresa a la que pertenece el usuario.
        st_llave:       "",

        st_modo:        "INGRESO",  // Por default es ingreso porque es la primera vista que tendrá el usuario
        st_enfoque:     false,

        /** Variables para el pagineo de registros */
        pagina: 1,
        lini:0, lfin: 5, limite: 5, diferencia: 5,
        esLimiteSup: false, esLimiteInf: true,

        /* Limites inicial y final para los Casos */
        Cpagina: 1, Clini: 0, Clfin: 5, CesLimiteSup: false, CesLimiteInf: true,
        
        /* Limites inicial y final para los Departamentos */
        Dpagina: 1, Dlini: 0, Dlfin: 5, DesLimiteSup: false, DesLimiteInf: true,

        /* Limites inicial y final para los Departamentos */
        Mpagina: 1, Mlini: 0, Mlfin: 5, MesLimiteSup: false, MesLimiteInf: true,
        
        /* Limites inicial y final para las áreas de salud */
        DASpagina: 1, DASlini: 0, DASlfin: 5, DASesLimiteSup: false, DASesLimiteInf: true,

        /* Limites inicial y final para las áreas de salud */
        DMSpagina: 1, DMSlini: 0, DMSlfin: 5, DMSesLimiteSup: false, DMSesLimiteInf: true,

        /* Limites inicial y final para los Tipos de Servicio */
        TSpagina: 1, TSlini: 0, TSlfin: 5, TSesLimiteSup: false, TSesLimiteInf: true,

        /* Limites inicial y final para los Servicios de Salud */
        SSpagina: 1, SSlini: 0, SSlfin: 5, SSesLimiteSup: false, SSesLimiteInf: true,

        /********************************************************************************************** */
        /* Limites inicial y final para los Servicios de Salud */
        CGpagina: 1, CGlini: 0, CGlfin: 5, CGesLimiteSup: false, CGesLimiteInf: true,
        Rpagina: 1, Rlini: 0, Rlfin: 5, ResLimiteSup: false, ResLimiteInf: true,
        
        /* Variables para un nuevo caso o el caso concurrente en la lista de casos. Funcionará para ON-LINE y OFF-LINE */
        st_caso: { 
            empresa: "Empresa Ejemplo", nombre:"Participante Ejemplo", 
            g1pg1: 0, g1pg2: 0, g1pg3: 0, g1pg4: 0, g1total: 0,
            g2pg1: 0, g2pg2: 0, g2pg3: 0, g2pg4: 0, g2total: 0,
            g3pg1: 0, g3pg2: 0, g3pg3: 0, g3pg4: 0, g3total: 0,
            g4pg1: 0, g4pg2: 0, g4pg3: 0, g4pg4: 0, g4total: 0,
            g5pg1: 0, g5pg2: 0, g5pg3: 0, g5pg4: 0, g5total: 0,
            g6pg1: 0, g6pg2: 0, g6pg3: 0, g6pg4: 0, g6total: 0,
            r1suma: 0, r1prom: 0, r2suma: 0, r2prom: 0,
            r3suma: 0, r3prom: 0, r4suma: 0, r4prom: 0,
        },
        /** Lista de casos, funciona solo en OFF-LINE */
        st_casos: [
            {
                empresa: "Empresa Prueba", nombre: "Participante 1",
                g1pg1: 10, g1pg2: 20, g1pg3: 30, g1pg4: 40, g1total: 100,
                g2pg1: 11, g2pg2: 12, g2pg3: 13, g2pg4: 64, g2total: 100,
                g3pg1: 20, g3pg2: 21, g3pg3: 22, g3pg4: 37, g3total: 100,
                g4pg1: 30, g4pg2: 31, g4pg3: 32, g4pg4: 7, g4total: 100,
                g5pg1: 80, g5pg2: 0, g5pg3: 0, g5pg4: 20, g5total: 100,
                g6pg1: 20, g6pg2: 0, g6pg3: 0, g6pg4: 80, g6total: 100,
                r1suma: 171, r1prom:28.50, r2suma: 84, r2prom: 14.00,
                r3suma: 97, r3prom:16.17, r4suma: 248, r4prom: 41.30,                                        
            },
            {
                empresa: "Empresa Prueba", nombre: "Participante 2",
                g1pg1: 30, g1pg2: 40, g1pg3: 0, g1pg4: 0, g1total: 100,
                g2pg1: 50, g2pg2: 40, g2pg3: 5, g2pg4: 5, g2total: 100,
                g3pg1: 60, g3pg2: 20, g3pg3: 10, g3pg4: 10, g3total: 100,
                g4pg1: 70, g4pg2: 10, g4pg3: 10, g4pg4: 10, g4total: 100,
                g5pg1: 40, g5pg2: 20, g5pg3: 20, g5pg4: 20, g5total: 100,
                g6pg1: 20, g6pg2: 50, g6pg3: 15, g6pg4: 15, g6total: 100,
                r1suma: 171, r1prom:28.50, r2suma: 84, r2prom: 14.00,
                r3suma: 97, r3prom:16.17, r4suma: 248, r4prom: 41.30,                                        
            },
            {
                empresa: "Empresa Prueba", nombre: "Participante 3",
                g1pg1: 80, g1pg2: 10, g1pg3: 10, g1pg4: 0, g1total: 100,
                g2pg1: 70, g2pg2: 15, g2pg3: 15, g2pg4: 0, g2total: 100,
                g3pg1: 60, g3pg2: 15, g3pg3: 10, g3pg4: 15, g3total: 100,
                g4pg1: 50, g4pg2: 20, g4pg3: 15, g4pg4: 15, g4total: 100,
                g5pg1: 40, g5pg2: 25, g5pg3: 15, g5pg4: 20, g5total: 100,
                g6pg1: 30, g6pg2: 15, g6pg3: 20, g6pg4: 35, g6total: 100,
                r1suma: 330, r1prom:55.00, r2suma: 100, r2prom: 16.67,
                r3suma: 85, r3prom:14.17, r4suma: 85, r4prom: 14.17,
            },                        
        ],
    },
    getters: getters,
    mutations: mutations, // mutations
});


// WEBPACK FOOTER //
// ./src/store/store.js